import {PdpService} from 'lib/apis/services/PdpSingle';
import useOwnRouter from 'lib/hooks/useOwnRouter';
import moment from 'moment';
import Image from 'next/image';
import Link from 'next/link';
import get from "lodash/get";

function MobileContactInfo() {
    const router = useOwnRouter();
    const {data} = PdpService.usePdpSingleQuery(
        router.router.query.id as string
    );

    const pdpContectInfo = data?.data.listing.agency;
    return (
        <div className="flex md:hidden flex-col">
            <Link
                prefetch={false}
                href={`/real-estate-agencies/detail/${pdpContectInfo?.id}`}
            >
                <a>
                    <Image
                        src={pdpContectInfo?.logo+"?q=large" || ''}
                        width={53}
                        height={53}
                        className="rounded-md !max-w-[32px] !max-h-[32px] !min-w-[32px] !min-h-[32px] "
                        alt={pdpContectInfo!.name}
                        placeholder="blur"
                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcvgAAAfQBSWu8iX0AAAAASUVORK5CYII="
                        onError={(err) => {
                            err.currentTarget.src = 'https://cdn.kilid.com/default-logo.png';
                            err.currentTarget.srcset = '';
                        }}
                    />
                </a>
            </Link>
            <p className="text-xs text-center">{pdpContectInfo?.name}</p>
            <b className="text-xs text-center">
                {data?.data.listing?.searchDate ? moment(data.data.listing.searchDate).fromNow() : ""}
                {/*{moment(data.data.listing?.searchDate).fromNow()}*/}
            </b>
        </div>
    );
}

export default MobileContactInfo;
